import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { Metamodel } from 'app/model/base/model';
import { Model } from 'app/model/backendmodel';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { BitbucketCopySource } from 'app/model/pipeline/copysource/bitbucket.copysource';
import { CopySourceAdapter, commonCopySourceAdapts } from 'app/model/adapters/activities/copysource/copysource.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(BitbucketCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        batchSize: '*'
    }
})
export class BitbucketCopySourceAdapter extends CopySourceAdapter<BitbucketCopySource, Model.BitbucketSource> {
    protected async _toResource(copySource: BitbucketCopySource): Promise<Model.BitbucketSource> {
        const resource = this._toTabularResource(
            copySource,
            Metamodel.modelFor(BitbucketCopySource).name
        ) as Model.BitbucketSource;
        resource.batchSize = ValueAdapter.toResource(copySource, BitbucketCopySource.BATCH_SIZE);
        return resource;
    }

    protected async _toModel(
        resource: Model.BitbucketSource,
        copyActivity: CopyActivity
    ): Promise<BitbucketCopySource> {
        const copySource = this._toTabularModel(
            resource,
            copyActivity,
            BitbucketCopySource.MODEL
        ) as BitbucketCopySource;
        ValueAdapter.toModel(copySource, BitbucketCopySource.BATCH_SIZE, resource.batchSize);
        return copySource;
    }
}
